import React, { useRef } from "react";
import Router from "./Routers/webappRouter";
// import "./App.css";
import { connect } from "react-redux";
//import Header from "./components/Header";
import history from "./Utils/History";
import { InternationalizationProvider } from "react-internationalization";
import * as languages from "./components/translations";
import {
  guestLogin,
  savelang,
  setTokenTORedux,
  getMembershipAgentList,
  getCustomerSubdomain,
  getStates,
} from "./Redux/Actions/webAppActions";
//import ReactGA from "react-ga";
//import { IdleTimerProvider, useIdleTimerContext } from "react-idle-timer";
import Modal from "react-bootstrap/Modal";
import { INITIAL_STATE } from "./components/initialState";
import AppLayout from "./Themes";
import { sessionExpired } from "./Redux/Actions/keyCloakAction";
import { jwtDecode } from "jwt-decode";
import { setLoginStateParams } from "./Redux/Actions/webAppActions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import TagManager from "react-gtm-module";
import { SHARP_CONSTS } from "./Utils/StaticData/Constant";
let set = 1;
let timeOutId;
let expireDuration;
let tokenExpiryTime;
let bufferTime = 300000; //5 min in mili
let idleTimeOutId;
const App = (props) => {
  const [show, setshow] = React.useState(false);
  //const [idle, setIdle] = React.useState(1499000);
  const [snack, setSnack] = React.useState({
    snackBarOpen: false,
    vertical: "top",
    horizontal: "center",
    snackBarSeverty: "",
    snackBarMsg: "",
  });
  let idle = 1499000;
  let exp = useRef(null);
  let isRefresh = useRef(true);
  let t;
  const tagManagerArgs = {
    gtmId: "GTM-T55TZNMZ",
  };
  React.useEffect(() => {
    const user = async () => {
      //const customer=
      const response = await props.getCustomerSubdomain();
      window.sessionStorage.setItem("customerId", response?.data.customerId);

      if (response?.data.customerId === SHARP_CONSTS.SHARP_CUSTOMER_ID) {
        TagManager.initialize(tagManagerArgs);
      }
    };
    user();
    // ReactGA.initialize("UA-196938588-1");
    //console.log(window.location.pathname + window.location.search);
    // Page View
    //ReactGA.pageview(window.location.pathname + window.location.search);
    window.scrollTo(0, 0);
  }, []);
  // React.useEffect(() =>{
  //   //used to appy the customer specific css
  //   if(props.customerId!==""){
  //   if(props.customerId==="HCF0331"){
  //     require('./assests/css/SharpCustomer/spinner.css')
  //         require('./assests/css/SharpCustomer/style.css')
  //         require('./assests/css/SharpCustomer/bstyle.css')
  //   }else if(props.customerId==="HCF0999"){
  //     require('./assests/css/spinner.css')
  //         require('./assests/css/style.css')
  //         require('./assests/css/bstyle.css')
  //   }
  // }
  // },[props.customerId])

 

  let url = window.location.href;
  let num = window.location.href.toString().indexOf("lang");
  let val;
  if (num > -1) {
    let queryString = window.location.search;
    if (queryString.includes("deepLink=true")) {
      let queryStringArray = queryString.split("&");
      queryStringArray.forEach((element) => {
        if (element.includes("lang")) {
          val = window.atob(element.split("=")[1]);
          console.log("num..", val);
        }
      });
    } else {
      console.log("num 2..")
      val = url.substring(num).substring(5);
      if (val.trim() !== "es" && val.trim() !== "en") {
        val = window.atob(val);
      }
    }
    sessionStorage.setItem("lang", val??"en");
    
  }
  if (val) {
    props.savelang(val);
    set = 0;
  } else if (!val && set) {
    let resl = sessionStorage.getItem("lang");
    if (resl) {
      props.savelang(resl);
      val = resl;
    } else {
      props.savelang("en");
      val = "en";
    }
  }

  React.useEffect(() => {
    // console.log("auto 1");
    if (props.isAgentLogin || props.guestLogin || props.beneficiaryLogin) {
      // if (props.idleTime !== 0) {
      //   let idleTm = props.idleTime * 1000;
      //   setIdle(idleTm);
      // }
      // console.log("auto 2", props?.token, props.isActive);
      if (
        props?.token !== "" &&
        props?.token !== null &&
        props.isActive === true &&
        !show
      ) {
        let exp2 = jwtDecode(props?.token).exp; //in second since epoch(1970 jan 1)
        tokenExpiryTime = new Date(exp2 * 1000).getTime();
        expireDuration = tokenExpiryTime - new Date().getTime();
        // let sessionTime = expireDuration - bufferTime; //time interval when we show pop up
        //idle = expireDuration - bufferTime; //time interval when we show pop up
        //idle = returnIdleTime();
        // setIdle(sessionTime);
        // console.log("auto 3");
        isRefresh.current = true;
        clearInterval(timeOutId);
        clearInterval(idleTimeOutId);
        timeOutId = setInterval(() => {
          // console.log("auto 4");
          //console.log("refresheed automatic1", props.isActive);
          if (props.isActive) {
            //  console.log("auto 5");
            //console.log("not show", show, props.isActive);
            automaticRefresh();
          }
        }, expireDuration - 120000); // expireDuration - 120000
      } else {
        //clearInterval(timeOutId);
      }
    } else {
      // clearInterval(timeOutId);
      //clearInterval(idleTimeOutId);
    }
  }, [
    props.isAgentLogin,
    props.guestLogin,
    props.beneficiaryLogin,
    props.idleTime,
    props.token,
    props.isActive,
  ]);
  React.useEffect(() => {
    if (props.isExpired === "true" || props.isExpired === true) {
      setshow(true);
      exp.current = true;
    } else if (exp.current === true && props.isExpired === null) {
      exp.current = null;
      if (props.isAgentLogin === true) {
        window.location.href = `${props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;
      } else {
        props.setTokenTORedux("");
        history.push("/e-Enroll/Login");
      }
    }
  }, [props.isExpired]);

  const idleHandler = () => {
    if (props.isPage !== "login") {
      isRefresh.current = false;
      clearInterval(timeOutId);
      clearInterval(idleTimeOutId);
      setshow(true);
      props.setLoginStateParams("isActive", false);
      let idleTimeOut = tokenExpiryTime - new Date().getTime();
      idleTimeOutId = setInterval(() => {
        setshow(false);
        //history.push("/e-Enroll/Login");
        if (props.isAgentLogin === true) {
          window.location.href = `${props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;
        } else {
          history.push("/e-Enroll/login");
        }
        setSnack({
          snackBarOpen: true,
          vertical: "top",
          horizontal: "center",
          snackBarSeverty: "error",
          snackBarMsg: "Session Expired.",
        });

        clearInterval(timeOutId);
        clearInterval(idleTimeOutId);
      }, idleTimeOut); //idleTimeOut
      // console.log("idle time came");
    }
  };
  const automaticRefresh = async () => {
    //  if (isRefresh.current === true) {
    await props.getStates();
    //clearInterval(timeOutId);
    // } else {
    //   clearInterval(timeOutId);
    // }
  };
  const yesHandler = async () => {
    isRefresh.current = true;
    setshow(false);
    // let exp1 = jwtDecode(props.token).exp; //in second since epoch(1970 jan 1)
    //let tokenExpiryTime1 = new Date(exp1 * 1000).getTime();
    // let expireDuration1 = tokenExpiryTime1 - new Date().getTime();

    // if (expireDuration1 <= 300000) {
    await props.getStates();
    //}
    clearInterval(timeOutId);
    clearInterval(idleTimeOutId);
    props.setLoginStateParams("isActive", true);
  };
  const noHandler = async () => {
    isRefresh.current = true;
    setshow(false);
    await props.setTokenTORedux("");
    clearInterval(timeOutId);
    clearInterval(idleTimeOutId);
    props.setLoginStateParams("isActive", true);
    if (props.isAgentLogin === true) {
      window.location.href = `${props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;
    } else {
      history.push("/e-Enroll/login");
    }
    //history.push("/e-Enroll/login");
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack({
      snackBarOpen: false,
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
      snackBarMsg: "",
    });
  };
  React.useEffect(() => {
    if (
      props.isAgentLogin === true ||
      props.guestLogin === true ||
      props.beneficiaryLogin === true
    ) {
      idleLogout();
    }
  }, [
    props.isAgentLogin,
    props.guestLogin,
    props.beneficiaryLogin,
    props.token,
    props.isActive,
    //idle,
    //props.idleTime,
  ]);

  const returnIdleTime = () => {
    let exp2 = jwtDecode(props.token).exp; //in second since epoch(1970 jan 1)
    tokenExpiryTime = new Date(exp2 * 1000).getTime();
    expireDuration = tokenExpiryTime - new Date().getTime();
    // let sessionTime = expireDuration - bufferTime; //time interval when we show pop up
    // idle = expireDuration - bufferTime; //time interval when we show pop up
    return expireDuration - bufferTime; //time interval when we show pop up
    //return 299743; //time interval when we show pop up
  };

  const idleLogout = async () => {
    if (
      (props.isAgentLogin || props.guestLogin || props.beneficiaryLogin) &&
      props.token !== "" &&
      props.isActive === true
    ) {
      idle = returnIdleTime();
    } else {
      idle = 1000 * 86400;
    }
    // console.log("working inside reset function..");
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer; // catches touchscreen presses as well
    window.ontouchstart = resetTimer; // catches touchscreen swipes as well
    window.ontouchmove = resetTimer; // required by some devices
    window.onclick = resetTimer; // catches touchpad clicks as well
    window.onkeydown = resetTimer;
    window.addEventListener("scroll", resetTimer, true); // improved; see comments
  };
  function resetTimer() {
    // console.log("outTime", idle);
    clearTimeout(t);
    t = setTimeout(idleHandler, idle); // time is in milliseconds
  }

  const { vertical, horizontal, snackBarOpen, snackBarMsg, snackBarSeverty } =
    snack;
  return (
    <InternationalizationProvider
      defaultLanguage={val}
      languages={languages}
      dynamicImports
    >
      {/* {console.log("idle-", idle)} */}
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={snackBarSeverty}>
          {snackBarMsg}
        </Alert>
      </Snackbar>
      {/* <IdleTimerProvider
        timeout={
          props.isAgentLogin || props.guestLogin || props.beneficiaryLogin
            ? idle
            : 1000 * 86400
        }
        onIdle={idleHandler}
        element={document}
      > */}
      <React.Fragment>
        {(props.isAgentLogin === true ||
          props.guestLogin === true ||
          props.beneficiaryLogin === true) && (
          <Modal
            show={show}
            backdrop="static"
            onHide={() => yesHandler()}
            centered
          >
            <Modal.Body>
              {props.isExpired !== "true" && props.isExpired !== true ? (
                <>
                  <h4 class="section-head">Session Timed out. </h4>
                  <div>
                    <p>Do you wish to continue with this session?</p>
                  </div>
                  <button
                    onClick={() => yesHandler()}
                    className="btn-primary-continue mr-3 idle-yes"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => noHandler()}
                    className="btn btn-dashboard idle-no"
                  >
                    No
                  </button>
                </>
              ) : (
                <>
                  <h4 class="section-head">Session Expired.</h4>
                  <button
                    onClick={() => {
                      clearInterval(idleTimeOutId);
                      props.sessionExpired(null);
                      setshow(false);
                      window.sessionStorage.setItem("isExpired", null);
                    }}
                    className="btn-primary-continue mr-3 idle-yes"
                  >
                    OK
                  </button>
                </>
              )}
            </Modal.Body>
          </Modal>
        )}
        <title> e-EnrollPlus Wipro Health Plan</title>

        <AppLayout>
          <Router />
        </AppLayout>
      </React.Fragment>
      {/* </IdleTimerProvider> */}
    </InternationalizationProvider>
  );
};
const mapStateToProps = (state) => {
  return {
    subDomain: state.login.subDomain,
    isLoading: state.spinner.isLoading,
    lang: state.webApp.language,
    isAgentLogin: state.login.agentLoggedIn,
    guestLogin: state.login.guestLogin,
    beneficiaryLogin: state.login.beneficiaryLogin,
    idleTime: state.login.idleTime,
    customerId: state.login.customerId,
    customerSubdomainDetails: state.login.customerSubdomainDetails,
    isExpired: state.spinner.isExpired,
    isActive: state.login.isActive,
    token: state.login.token,
  };
};
const mapDispatchToProps = {
  savelang,
  setTokenTORedux,
  getMembershipAgentList,
  getCustomerSubdomain,
  sessionExpired,
  setLoginStateParams,
  getStates,
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
